// Srs推流地址, 目前需要, 未来不确定
import axios from "axios";
import { srsUrl } from "./basic";

const service = axios.create({
  baseURL: srsUrl,
  timeout: 20000,
  transformRequest: [
    function(data) {
      let ret = "";
      for (const it in data) {
        ret +=
          encodeURIComponent(it) + "=" + encodeURIComponent(data[it]) + "&";
      }
      return ret;
    }
  ],
  // 设置请求头 || 设置
  headers: {
    "Content-Type": "application/x-www-form-urlencoded"
  }
});

service.interceptors.request.use(
  config => {
    return config;
  },
  error => {
    console.log(error); // for debug    return Promise.reject(error);
  }
);

service.interceptors.response.use(
  response => {
    return response.data;
  },
  error => {
    console.log("err" + error); // for debug
    return Promise.reject(error);
  }
);
export default service;
